export const aboutInfo = {
  brandName: "汗汗漫画",
  slogan: "更新最快的漫画网 — 好看的免费漫画大全",
  founded: "2018年",
  mission: "让每一位漫画爱好者都能第一时间畅享最新、最全、最高质量的漫画内容，打造极致的阅读体验。",
  intro: "汗汗漫画成立于2018年，是国内领先的免费漫画在线阅读平台之一。我们以\"更新速度最快\"为核心竞争力，汇聚海量韩漫、日漫、国漫资源，致力于为漫画爱好者提供无广告干扰、高品质的阅读体验。无论是热门连载还是经典完结，汗汗漫画都力争在第一时间为您呈现。",
  stats: [
    { label: "漫画总数", value: "50,000+" },
    { label: "日活跃用户", value: "200万+" },
    { label: "累计阅读量", value: "100亿+" },
    { label: "合作作者", value: "3,000+" },
  ],
  features: [
    {
      title: "更新速度最快",
      description: "我们拥有专业的翻译和更新团队，热门漫画实现实时同步更新，让您永远快人一步。",
      icon: "ri-flashlight-fill",
    },
    {
      title: "海量漫画资源",
      description: "涵盖韩漫、日漫、国漫三大品类，收藏超过5万部漫画作品，满足不同读者的口味需求。",
      icon: "ri-database-2-fill",
    },
    {
      title: "无遮挡阅读体验",
      description: "提供清爽无遮挡的阅读界面，沉浸式阅读体验，让您完全沉浸在漫画世界中。",
      icon: "ri-eye-fill",
    },
    {
      title: "永久免费",
      description: "坚持免费阅读理念，所有漫画均可免费在线阅读，无需付费订阅，真正的漫画自由。",
      icon: "ri-vip-diamond-fill",
    },
  ],
  testimonials: [
    {
      name: "漫画迷小王",
      avatar: "",
      content: "汗汗漫画真的是我见过更新最快的网站了！追的几部韩漫基本同步更新，而且画质超清，阅读体验一流。",
      rating: 5,
    },
    {
      name: "二次元爱好者",
      avatar: "",
      content: "用汗汗漫画三年了，资源越来越丰富，界面也越来越好看。最爱的就是无遮挡模式，看起来很舒服。",
      rating: 5,
    },
    {
      name: "连载追更人",
      avatar: "",
      content: "每天必刷汗汗漫画，更新速度真的没话说。而且分类很清晰，找漫画很方便，强烈推荐！",
      rating: 5,
    },
  ],
  contact: {
    email: "contact@hanhanmanhua.com",
    wechat: "hanhanmanhua",
    weibo: "@汗汗漫画官方",
    qq: "1234567890",
  },
  faqs: [
    {
      question: "汗汗漫画的漫画多久更新一次？",
      answer: "我们拥有专业的翻译更新团队，热门漫画通常能在原版发布后24小时内完成翻译更新，部分头部作品甚至可以实现同步更新。具体更新频率取决于原作的发布节奏。",
    },
    {
      question: "汗汗漫画需要付费吗？",
      answer: "不需要！汗汗漫画始终坚持免费阅读理念，所有漫画内容均可免费在线阅读，无需任何付费订阅。我们通过广告收入来维持运营，为大家提供持续的免费服务。",
    },
    {
      question: "支持哪些设备阅读？",
      answer: "汗汗漫画全面支持PC端、平板和手机端阅读。无论是在电脑上还是移动设备上，都能获得流畅的阅读体验。推荐使用手机端阅读，体验更佳。",
    },
    {
      question: "如何找到我想看的漫画？",
      answer: "您可以通过首页的分类导航、搜索功能，或者排行榜来找到感兴趣的漫画。我们也提供个性化推荐，根据您的阅读历史为您推荐可能喜欢的作品。",
    },
    {
      question: "遇到阅读问题怎么办？",
      answer: "如果您在使用过程中遇到任何问题，可以通过页面的联系方式与我们取得联系，我们的客服团队会在24小时内为您解决问题。",
    },
  ],
};